import { render, staticRenderFns } from "./DataTableActions.vue?vue&type=template&id=3dae9fdb&"
import script from "./DataTableActions.vue?vue&type=script&lang=js&"
export * from "./DataTableActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports